/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Filters_Status_Label1Inputs */

const en_settings_casmanagement_filters_status_label1 = /** @type {(inputs: Settings_Casmanagement_Filters_Status_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Settings_Casmanagement_Filters_Status_Label1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_filters_status_label1 = /** @type {((inputs?: Settings_Casmanagement_Filters_Status_Label1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Filters_Status_Label1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_filters_status_label1(inputs)
});
export { settings_casmanagement_filters_status_label1 as "settings_casManagement_filters_status_label" }